import {
  Box,
  Flex,
  IconButton,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Spacer,
  Stack,
} from '@chakra-ui/react'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons'
import { range } from 'lodash-es'
import { Fragment } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import useLayoutContext from '@/components/Layout/useLayoutContext'
import Icon from '@/components/UI/Icon/Icon'

function ConversationListLoading(): React.ReactElement {
  const { navbarOffsetPx } = useLayoutContext()
  return (
    <Stack height={`calc(100vh - 200px - ${navbarOffsetPx})`}>
      <Skeleton height="40%" borderBottom={`1px solid ${chakraTokenToVar('border.muted')}`} />
      <Skeleton height="40%" borderBottom={`1px solid ${chakraTokenToVar('border.muted')}`} />
      <Skeleton height="40%" borderBottom={`1px solid ${chakraTokenToVar('border.muted')}`} />
    </Stack>
  )
}

const SKELETON_COUNT = 4
const NEW_MESSAGE_HEIGHT = '106px'
const HEADER_HEIGHT = '70px'

export function ConversationSingleLoading(): React.ReactElement {
  const { navbarOffsetPx } = useLayoutContext()

  return (
    <Stack height="100%">
      <Stack
        direction="row"
        minHeight={HEADER_HEIGHT}
        borderBottom="2px solid"
        borderColor="border.emphasized"
        justifyContent="center"
        zIndex={2}
        px="20px"
        align="center"
      >
        <IconButton
          variant="icon"
          icon={<Icon faIcon={faChevronLeft} size="md" />}
          aria-label="Back to messages"
          isDisabled
          display={{ base: 'flex', md: 'none' }}
          mr={{ base: '16px', md: '0' }}
        />
        <SkeletonCircle size="32px" mr="16px" />
        <SkeletonText noOfLines={1} skeletonHeight="12px" flex={1} />
      </Stack>
      <Stack
        height={`calc(100vh - ${navbarOffsetPx} -  ${NEW_MESSAGE_HEIGHT} - ${HEADER_HEIGHT})`}
        overflow="clip"
        px="16px"
        spacing="32px"
      >
        {range(SKELETON_COUNT).map(i => (
          <Fragment key={i}>
            <Stack direction="row" align="center" spacing="16px" mt="32px">
              <SkeletonCircle size="32px" />
              <SkeletonText mt="4" noOfLines={4} spacing="16px" flex={1} />
            </Stack>
            <Stack direction="row" align="center" spacing="16px">
              <SkeletonText mt="4" noOfLines={4} spacing="16px" flex={1} />
              <SkeletonCircle size="32px" />
            </Stack>
          </Fragment>
        ))}
      </Stack>
      <Spacer />
      <Box
        width="100%"
        minHeight={NEW_MESSAGE_HEIGHT}
        flexShrink={0}
        borderTop="2px solid"
        borderColor="border"
        p="16px"
      >
        <Skeleton height="100%" width="100%" />
      </Box>
    </Stack>
  )
}

export default function ConversationLoading(): React.ReactElement {
  const { navbarOffsetPx } = useLayoutContext()

  return (
    <Flex flexDirection="row" height={`calc(100vh - ${navbarOffsetPx})`}>
      <Flex
        flexDirection="column"
        width={{ base: '100%', md: '50%' }}
        display={{ base: 'none', md: 'flex' }}
      >
        <ConversationListLoading />
      </Flex>
      <Flex
        flexDirection="column"
        width="100%"
        display={{ base: 'flex', md: 'flex' }}
        borderLeft="2px solid"
        borderColor="border.emphasized"
      >
        <ConversationSingleLoading />
      </Flex>
    </Flex>
  )
}
